import { NAN_PARAMS, PARAMS_NAME } from "../PushapiHourly/config";

import React from "react";

import PushapiPostbackForm from "./components/Form";
import Container from "../../components/Container";
import Heading from "../../components/Heading";
import Table from "../../components/StatsTable";
import API from "../../services/API";

export default class PushapiPostbackDaily extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            affids: [],
            subids: [],
            filters: [],
            report: [],
            params: [],
            total: [],
            loading: false
        }

        this.onSubmit = this.onSubmit.bind(this);
        this.load = this.load.bind(this);
    }

    async load(promise) {
        this.setState({ loading: true });

        return promise
            .then((data) => data)
            .catch((error) => error)
            .finally(() => this.setState({ loading: false }))
    }

    async onSubmit(filters, type) {
        const data = await (() => {
            switch (type) {
                case "load_report": return this.load(API.PushapiPostback.get('daily', filters));
                case "load_affid": return this.load(API.PushapiPostback.list('daily', 'affid', filters));
                case "load_subid": return this.load(API.PushapiPostback.list('daily', 'subid', filters));
            }
        })();

        if (type === "load_report") this.setState({ report: data.report, params: data.params, total: data.total || [] });
        if (type === "load_affid") this.setState({ affids: data });
        if (type === "load_subid") this.setState({ subids: data });
    }

    render() {
        const { params = [], report, total } = this.state;

        const paramsObj = params.reduce((object, param, index) => ({ ...object, [param]: index }), {});

        return (
            <Container loading={this.state.loading}>
                <Heading title="Pushapi Postback Daily" />

                <PushapiPostbackForm onSubmit={this.onSubmit} affids={this.state.affids} subids={this.state.subids} />

                <Table params={params} paramsObj={paramsObj} report={report} total={total} paramNames={PARAMS_NAME} NaNParams={NAN_PARAMS}/>
            </Container>
        )
    }
}


// WEBPACK FOOTER //
// ./src/scenes/PushapiPostbackDaily/index.js